import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './dark.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Provider} from "react-redux";
import configureStore from "./configureStore";
import Interceptor from "./api/apiInterceptor";
import safariPolyfill from '../src/util/safariPolyfill';
safariPolyfill();

const store = configureStore();

Interceptor.interceptor(store);

ReactDOM.render(
    <Provider store={store}>
        <App/>
    </Provider>,
    document.getElementById('root')
);

reportWebVitals();
